<template>
  <div>
    <h1>Document à Imprimer</h1>
    <button class="button" @click="sendPrintRequest">Imprimer Document</button>
  </div>
</template>

<script>
import axios from "axios";

export default {
  methods: {
    async sendPrintRequest() {
      try {
        const response = await axios.post("http://localhost:3000/print", {
          content: "<h1>Ceci est un document à imprimer</h1>",
        });
        console.log("Impression envoyée:", response.data);
      } catch (error) {
        console.error("Erreur d'impression:", error);
      }
    },
  },
};
</script>
